module.exports = __webpack_public_path__ + "img/img-business-global-sec-10.png";